import React, { useState, useEffect } from 'react';
import { Box, Typography, useTheme, Button, Grid } from "@mui/material";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { tokens } from "../../theme";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import Header from "../../components/Header";
import { useNavigate } from "react-router-dom";
import axios from 'axios';

const Colaboradores = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const navigate = useNavigate();

  const [colaboradores, setColaboradores] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchColaboradores = async () => {
      try {
        const response = await axios.get("https://pf-auditores.ew.r.appspot.com/api/colaboradores");
        const colaboradoresData = response.data.map(colaborador => ({
          ...colaborador,
          // Adicionando um campo nomeAbreviado que contém o primeiro e último nome abreviados
          nomeAbreviado: `${colaborador.nome.split(' ')[0]} ${colaborador.nome.split(' ')[colaborador.nome.split(' ').length - 1]}`,
        }));
        setColaboradores(colaboradoresData);
      } catch (error) {
        console.error("Erro ao buscar colaboradores:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchColaboradores();
  }, []);

  const handleEdit = (id) => {
    navigate(`/colaboradores/editar/${id}`);
  };

  const handleDelete = (id) => {
    const confirmDelete = window.confirm("Tem certeza que deseja remover este colaborador?");
    if (confirmDelete) {
      axios.delete(`https://pf-auditores.ew.r.appspot.com/api/colaboradores/${id}`)
        .then(() => {
          setColaboradores(colaboradores.filter(colaborador => colaborador.id !== id));
          alert("Colaborador removido com sucesso!");
        })
        .catch(error => {
          console.error("Erro ao remover colaborador:", error);
          alert("Erro ao remover colaborador. Por favor, tente novamente mais tarde.");
        });
    }
  };

  const columns = [
    {
      field: "nomeAbreviado",
      headerName: "Nome",
      flex: 0.5,
      cellClassName: "name-column--cell",
      renderCell: (params) => {
        return (
          <Typography
            variant="body1"
            onClick={() => handleEdit(params.row.id)}
            style={{ cursor: "pointer", color: colors.greenAccent[300] }}
          >
            {params.value}
          </Typography>
        );
      },
    },
    {
      field: "cargo",
      headerName: "Cargo",
      flex: 0.3,
      renderCell: (params) => {
        return params.row.cargo ? params.row.cargo : "";
      },
    },
    {
      field: "email",
      headerName: "E-mail",
      flex: 0.6,
      renderCell: (params) => {
        return params.row.email ? params.row.email : "";
      },
    },
    {
      field: "tipo",
      headerName: "Tipo de Acesso",
      flex: 0.3,
      renderCell: (params) => {
        return params.row.tipo ? params.row.tipo : "";
      },
    },
    {
      field: "valorHora",
      headerName: "Valor Hora",
      flex: 0.3,
      renderCell: (params) => {
        return params.row.valorHora;
      },
    },
    {
      field: "edit",
      headerName: "",
      flex: 0.3,
      renderCell: (params) => {
        return (
          <Button
            variant="contained"
            color="primary"
            size="small"
            startIcon={<EditIcon />}
            onClick={() => handleEdit(params.row.id)}
          >
            Editar
          </Button>
        );
      },
    },
    {
      field: "delete",
      headerName: "",
      flex: 0.3,
      renderCell: (params) => {
        return (
          <Button
            variant="contained"
            color="secondary"
            size="small"
            startIcon={<DeleteIcon />}
            onClick={() => handleDelete(params.row.id)}
          >
            Remover
          </Button>
        );
      },
    },
  ];

  return (
    <Box m="20px">
      <Header title="Colaboradores" subtitle="Lista de colaboradores registrados" />
      <Grid container justifyContent="space-between" marginBottom="20px">
        <Grid item>
          <Button variant="contained" color="primary" onClick={() => navigate('/colaboradores/registar')}>
            Adicionar Colaborador
          </Button>
        </Grid>
      </Grid>
      <Box
        m="40px 0 0 0"
        height="75vh"
        sx={{
          "& .MuiDataGrid-root": {
            border: "none",
          },
          "& .MuiDataGrid-cell": {
            borderBottom: "none",
          },
          "& .name-column--cell": {
            color: colors.greenAccent[300],
          },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: colors.blueAccent[700],
            borderBottom: "none",
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: colors.primary[400],
          },
          "& .MuiDataGrid-footerContainer": {
            borderTop: "none",
            backgroundColor: colors.blueAccent[700],
          },
          "& .MuiCheckbox-root": {
            color: `${colors.greenAccent[200]} !important`,
          },
          "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
            color: `${colors.grey[100]} !important`,
          },
        }}
      >
        <DataGrid
          rows={colaboradores}
          columns={columns}
          components={{ Toolbar: GridToolbar }}
          loading={isLoading} // Indicador de carregamento do DataGrid
        />
      </Box>
    </Box>
  );
};

export default Colaboradores;
